import { cn } from '../../lib/utils';

const statusConfig = {
  en_attente: {
    label: 'En attente',
    className: 'bg-gray-100 text-gray-600 border-gray-200'
  },
  validee: {
    label: 'Validée',
    className: 'bg-blue-50 text-blue-600 border-blue-200'
  },
  en_route: {
    label: 'En route',
    className: 'bg-amber-50 text-amber-600 border-amber-200'
  },
  en_cours: {
    label: 'En cours',
    className: 'bg-purple-50 text-purple-600 border-purple-200'
  },
  terminee: {
    label: 'Terminée',
    className: 'bg-emerald-50 text-emerald-600 border-emerald-200'
  },
  encaissee: {
    label: 'Encaissée',
    className: 'bg-green-100 text-green-700 border-green-200'
  },
  annulee: {
    label: 'Annulée',
    className: 'bg-red-50 text-red-600 border-red-200'
  }
};

export default function StatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig.en_attente;

  return (
    <span 
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 text-xs font-semibold border rounded-full',
        config.className
      )}
      data-testid={`status-badge-${status}`}
    >
      {config.label}
    </span>
  );
}
